import { ClientBrandCode } from '@domgen/dgx-fe-common';
import { ApplianceDetailsSteppedIpsFormValue } from './appliance-details-stepped-ips-form-value.type';
import { CmsApplianceDetailsSteppedForm } from './cms-appliance-details-stepped-form.interface';

export interface ApplianceDetailsSteppedIpsFormConfig {
  applianceMaximumAge: Date;
  clientBrandCode?: ClientBrandCode;
  cmsData: CmsApplianceDetailsSteppedForm;
  initialValue: Partial<ApplianceDetailsSteppedIpsFormValue>;
}
